import { render, staticRenderFns } from "./deep-MT5.vue?vue&type=template&id=63ebec00&scoped=true&"
import script from "./deep-MT5.vue?vue&type=script&lang=js&"
export * from "./deep-MT5.vue?vue&type=script&lang=js&"
import style0 from "./deep-MT5.vue?vue&type=style&index=0&id=63ebec00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ebec00",
  null
  
)

export default component.exports